import { CC_PERMISSIONS, INotification, PERM_TYPES } from '@communication-center/data-objects';
import React from 'react';
import { useDispatch } from 'react-redux';
import TitleCell from '../../../../AppTable/cells/TitleCell/TitleCell';
import { updateNotificationNonRuntimeFields } from '../../../../../state/actions/notificationsList';
import { usePermissionCheck } from '../../../../../infrastructure/Permissions/PermissionsProvider';

export const NotificationTitle = ({ notification }: { notification: INotification }) => {
    const dispatch = useDispatch();
    const isEditAllowed = usePermissionCheck({
        creatorIds: [notification.user?.id as number],
        permissions: [CC_PERMISSIONS.AllNotifications, PERM_TYPES.Write]
    });

    return (
        <TitleCell
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            title={notification.title}
            subTitle={notification.runtimeTitle}
            id={notification.id}
            userId={notification?.user?.id}
            isEditableTitle={isEditAllowed}
            onTitleEdit={newTitle => {
                if (newTitle === notification.title) {
                    return;
                }
                dispatch(updateNotificationNonRuntimeFields({ ...notification, title: newTitle }));
            }}
        />
    );
};
